import { inject, Injectable } from '@angular/core'
import { FeathersService, PaginatedStoreWithData } from '../feathers.service'
import { JournalEntryHistoryItem } from '../../models/journal-entry-history-item'

@Injectable({
  providedIn: 'root',
})
export class JournalEntriesHistoryService {
  private readonly feathers = inject(FeathersService)

  createStore(assistanceId: number, clientId: number): PaginatedStoreWithData<JournalEntryHistoryItem, never> {
    return this.feathers.getPaginated<JournalEntryHistoryItem, never>(JournalEntryHistoryItem, {
      assistanceId,
      clientId,
      $skip: 0,
    })
  }
}
